import Box from 'UIKit/Box/Box'
import { RewardTypeEnum } from 'config/types/bonus/DailyReward'
import BonusRewardThumbnail from './BonusRewardThumbnail'
import CashRewardThumbnail from './CashRewardThumbnail'
import HUSDLockRewardThumbnail from './HUSDLockRewardThumbnail'

const RewardThumbnail = ({ rewardDetail, size }: { rewardDetail: any; size?: number }) => {
  return (
    <Box>
      {rewardDetail.rewardType === RewardTypeEnum.Bonus ? (
        <BonusRewardThumbnail bonusImage={rewardDetail.reward.bonusImage} size={size} />
      ) : rewardDetail.rewardType === RewardTypeEnum.HUSDLock ? (
        <HUSDLockRewardThumbnail size={size} />
      ) : (
        <CashRewardThumbnail token={rewardDetail.reward.token} size={size} />
      )}
    </Box>
  )
}

export default RewardThumbnail
